export const getFallbackFPS = () => {
  return 24;
};
